import 'firebase/messaging';
import { config } from './config';
import firebase from 'infras/firebase/client';
import { ViewerItem } from 'presentations/api/schema/user';
import { apiPath } from 'presentations/routes/path';
import { post } from 'infras/rest_client';
import { UserNotificationTokenCreateBody } from 'presentations/api/schema/user_notification_token';
import { DeviceType } from 'domains/models/user_notification_token/device_type';
import {
  getPersistentItem,
  setPersistentItem,
} from 'presentations/views/helpers/storage';

declare global {
  interface Window {
    registration: any;
  }
}

export const UserNotificationTokenKey = 'UserNotificationToken';

export async function initializeWebPush(viewer: ViewerItem) {
  const cachedToken = getPersistentItem(UserNotificationTokenKey);

  if (!firebase.apps.length) {
    firebase.initializeApp(config);
  }
  try {
    const messaging = firebase.messaging();

    // requesting notification permission from browser
    const status = await Notification.requestPermission();
    if (status && status === 'granted') {
      const fcmToken = await messaging.getToken();
      if (fcmToken) {
        if (fcmToken !== cachedToken) {
          const data: UserNotificationTokenCreateBody = {
            deviceType: DeviceType.Web,
            token: fcmToken,
          };
          const result = await post(
            apiPath(`/v1/user_notification_tokens/create`),
            {
              data,
            },
          );
          if (!result.isSuccess) {
            console.warn('notification token create failed');
          }

          // DBのupdatedAtを更新させるために、キャッシュ有効期限は1月にする
          // https://firebase.google.com/docs/cloud-messaging/manage-tokens?hl=ja
          setPersistentItem(UserNotificationTokenKey, fcmToken, 86400 * 30);
        }
        messaging.onMessage((payload) => {
          console.debug('[frontground] Received background message ', payload);
          const { title, body } = payload.notification;
          const options = {
            body,
          };
          self.registration.showNotification(title, options);
        });
      }
    } else {
      console.debug('Notification request permission', status);
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
